<template>
  <font-awesome-icon
    :style="cssProps"
    class="dotcom-icon"
    :icon="[iconArt, iconName]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import FontAwesomeIcon, { ART } from '@/config/icons'

export default {
  name: 'DotcomIcon',

  components: { FontAwesomeIcon },

  inheritAttrs: false,

  props: {
    name: {
      type: String,
      required: true,
    },

    art: {
      type: String,
      default: '',
    },

    color: {
      type: String,
      default: '',
    },

    hoverColor: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      iconName: '',
      iconArt: 'fal',
    }
  },

  computed: {
    cssProps() {
      /*
       * font color (this.color):
       * - if set: color applies
       * - if unset: color inherited from parent
       * hover color (this.hoverColor) (applies if icon itself is hovered, not necessary if parent is hovered):
       * - if set: color applies
       * - if unset: color inherited from parent
       */
      return {
        '--dotcom-icon-color': this.color ? `var(${this.color})` : 'inherit',
        '--dotcom-icon-hover-color': this.hoverColor
          ? `var(${this.hoverColor})`
          : '',
      }
    },
  },

  created() {
    this.updateIcon()
  },

  methods: {
    updateIcon() {
      this.iconName = this.name

      const nameParts = this.name.split('-')
      if (ART[nameParts[0]]) {
        this.iconArt = nameParts.shift()
        this.iconName = nameParts.join('-')
      }

      if (this.art) {
        this.iconArt =
          Object.keys(ART).find(key => ART[key] === this.art) ?? 'fal'
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.dotcom-icon {
  color: var(--dotcom-icon-color, --c-primary-color-3);

  &:hover {
    color: var(--dotcom-icon-hover-color);
  }
}
</style>
